/**
 * securityHelper.js
 * Created by michaelbray on 2/14/18.
 */

import moment from 'moment';

export function isLoggedIn() {
    const acct = window.localStorage.getItem('recaccount');
    if (acct == null) {
        return false;
    }

    const exp = JSON.parse(acct).expiration;
    if (moment.utc(exp).isAfter()) {
        return true;
    }

    window.localStorage.removeItem('recaccount');
    return false;
}

export function getRecAccount() {
    if (isLoggedIn()) {
        return JSON.parse(window.localStorage.getItem('recaccount'));
    }

    return {};
}

export function getAccount() {
    if (isLoggedIn()) {
        return getRecAccount().account;
    }

    return {};
}

export function isCommercialAccount() {
    const account = getAccount();

    if (Object.keys(account).length > 0 && account.hasOwnProperty('is_commercial_account')) {
        return account.is_commercial_account;
    }

    return false;
}

export function getAuthHeader() {
    if (isLoggedIn()) {
        return `Bearer ${getRecAccount().access_token}`;
    }

    return '';
}

export function getInternalAuthHeader() {
    const internalAccount = JSON.parse(window.localStorage.getItem('internalaccount'));
    if (internalAccount === null) {
        return '';
    }
    return `Bearer ${internalAccount.access_token}`;
}
